let Myarr = [];

let Count = 0;

export const setData = (obj) => {
  Myarr.push(obj)
  Count = Myarr.length;
}

export const cartCount = () => {
  return Count;
}

export const getdata = () => {
  return Myarr;
}